import { Breakpoints } from '@/constants/breakpoints';

export const isMobile = window.innerWidth < Breakpoints.maxMobileWidth;
export const isTablet =
  window.innerWidth < Breakpoints.maxTabletWidth &&
  window.innerWidth >= Breakpoints.maxMobileWidth;
export const isTabletAndLower = window.innerWidth < Breakpoints.maxTabletWidth;
